import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Segment from 'semantic-ui-react/dist/commonjs/elements/Segment/Segment';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import Checkbox from 'semantic-ui-react/dist/commonjs/modules/Checkbox/Checkbox';
import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon/Icon';
import styles from './TableRow.module.scss';

const TableRow = ({
  item, fields, handleRowClick, selectedItem,
  checkboxes, useActivation, goTo
}) => (
  <Segment
    disabled={useActivation && get(item, 'active') === false}
    className={(selectedItem == item.id) ? styles.active : ''} // eslint-disable-line eqeqeq
    onClick={handleRowClick(item.id)}
  >
    <Grid columns="equal">
      {!!checkboxes && (
      <Grid.Column key="checkbox" width={checkboxes ? 'one' : undefined}>
        <Checkbox onChange={checkboxes.onCheck(item.id)} checked={checkboxes.checkIfSelected(item.id)} />
      </Grid.Column>
      )}
      {fields.map(({ propName, propPath }) => (
        <Grid.Column
          key={propName}
          verticalAlign="middle"
          width={propName === 'id' ? 'one' : undefined}
        >
          {get(item, propName, '') || get(item, propPath, '')}
        </Grid.Column>
      ))}
      {!!goTo && (
        <Grid.Column width="one">
          <Icon
            style={{ color: '#2185D0' }}
            size="big"
            name="arrow alternate circle right"
            onClick={goTo(item.id)}
          />
        </Grid.Column>
      )}
    </Grid>
  </Segment>
);

TableRow.defaultProps = {
  selectedItem: null,
  checkboxes: null,
  goTo: () => {}
};

TableRow.propTypes = {
  item: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }).isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)])
  ).isRequired,
  selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checkboxes: PropTypes.shape({
    onCheck: PropTypes.func,
    checkIfSelected: PropTypes.func
  }),
  handleRowClick: PropTypes.func.isRequired,
  useActivation: PropTypes.bool.isRequired,
  goTo: PropTypes.func
};

export default TableRow;
